import React, {useContext, useEffect, useRef, useState} from 'react';
import {AgentContext} from "../../context/agent-context.jsx";
import DefaultHeader from "../../utils/default-header.jsx";
import UserPermission from "../user-permission.jsx";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import {FaLock, FaUnlock} from "react-icons/fa";
import {FaTriangleExclamation} from "react-icons/fa6";
import LoginBlock from "../login-block.jsx";
import ChangePassword from "../change-password.jsx";
import InputTextarea from "../../../../../../components/input/input-textarea.jsx";
import {Card} from "../../../../../../components/card/card.jsx";
import InputForm from "../../../../../../components/input/input-form.jsx";
import Button from "../../../../../../components/button/button.jsx";
import projectUtils from "../../../../../../utils/project-utils.js";
import Alert from "../../../../../../components/alert/alert.jsx";
import InputSwitch from "../../../../../../components/input/input-switch.jsx";
import vmsService from "../../../../../../services/web/vms-service.js";
import {toast} from "react-toastify";
import Vms from "./vms.jsx";
import userService from "../../../../../../services/web/user-service.js";

const MySwal = withReactContent(Swal);
const User = () => {
    const {
        user,
        setUser,
        id,
        setChanges,
        userRefetch,
        setIsLoading,
    } = useContext(AgentContext);
    const [loginBlockModal, setLoginBlockModal] = useState(false)
    const [changePasswordModal, setChangePasswordModal] = useState(false)

    const unBlock = () => {
        MySwal.fire({
            title: "Atenção",
            text: `Tem certeza que deseja desbloquear login de "${user.general.name}"?`,
            icon: "warning",
            confirmButtonText: "Sim",
            confirmButtonColor: "#063A6C",
            cancelButtonText: "Não",
            cancelButtonColor: "#c10007",
            showCancelButton: true,
            reverseButtons: true,
        }).then(({isConfirmed}) => {
            if (isConfirmed) {
                setIsLoading(true);
                userService.unblockLogin(id, DefaultHeader)
                    .then(() => {
                        userRefetch();
                        toast.success("Desbloqueado com sucesso")
                    })
                    .catch(() => projectUtils.swalErrorMessage("", "Não foi possível prosseguir.", "Ok"))
                    .finally(() => setIsLoading(false))
            }
        });
    }

    const onChange = (id, value) => {
        setUser(prev => ({...prev, user: {...user.user, [id]: value}}))
        setChanges('user');
    }

    const definePassword = () => {
        if (!id) {
            setChangePasswordModal(true)
            return
        }

        MySwal.fire({
            title: "Atenção",
            showCancelButton: true,
            html: `
                    Esta operação não pode ser desfeita!<br>
                    Para definir uma senha, digite <b>Definir senha</b> abaixo:
                `,
            confirmButtonText: "Confirmar",
            cancelButtonText: "Cancelar",
            confirmButtonColor: '#063A6C',
            input: "text",
            reverseButtons: true,
            preConfirm(inputValue) {
                if (inputValue.trim() !== "Definir senha") {
                    Swal.showValidationMessage(`Digite corretamente a palavra-chave`);
                }
            }
        }).then(({isConfirmed, isDenied, isDismissed}) => {
            if (isConfirmed) setChangePasswordModal(true);
        });
    }

    return (
        <div className={"h-[calc(100vh-131px)] overflow-x-hidden overflow-y-auto space-y-2"}>
            {user.user.status && <Alert target={"success"} className={"mb-2"}><b>Agente ativo</b></Alert>}
            {!user.user.status && <Alert target={"danger"} className={"mb-2"}><b>Agente inativo</b></Alert>}

            <Card>
                <Card.Header>
                    <Card.Title>Acesso ao sistema</Card.Title>
                </Card.Header>
                <Card.Body>
                    <div className="grid grid-cols-12 gap-4 mb-3">
                        <div className="col-span-6">
                            <InputForm
                                id="login"
                                value={user.user.login}
                                label="Login"
                                disabled={!user.user.status}
                                onChange={({target: {value, id}}) => onChange(id, value)}
                                className="text-upper"/>
                        </div>

                        <div className="col-span-6">
                            {
                                (id && user.user.loginBlocked) &&
                                <div className="block-user flex align-center gap-4">
                                    <Alert className={"p-0! text-[14px]! flex items-center pr-3! pl-3!"} target={"danger"}><b>{user.user.blockObservation}</b></Alert>
                                    <Button
                                        title="Desbloquear login"
                                        onClick={unBlock}
                                        actionFeedbackType="save"
                                        deferActionFeedback
                                        loadingText="Desbloqueando..."
                                        successText="Desbloqueado com sucesso"
                                    >
                                        <FaUnlock className={"me-1"}/> Desbloquear login
                                    </Button>
                                </div>
                            }

                            {
                                (id && !user.user.loginBlocked) &&
                                <Button target={"danger"} title="Bloquear login" onClick={() => setLoginBlockModal(true)}>
                                    <FaLock className={"me-1"}/> Bloquear login
                                </Button>
                            }
                        </div>
                    </div>

                    <UserPermission/>
                </Card.Body>
            </Card>

            <Card>
                <Card.Header>
                    <Card.Title>Segurança</Card.Title>
                </Card.Header>
                <Card.Body>
                    <div className="flex gap-3 items-center">
                        <InputSwitch
                            id="changePassword"
                            labelStyle={{fontSize: "15px"}}
                            disabled={!user.user.status || projectUtils.hasValue(user.user.password) || !projectUtils.hasValue(id)}
                            label="Trocar a senha no próximo login"
                            checked={user.user.changePassword  || !projectUtils.hasValue(id)}
                            onChange={(checked) => onChange('changePassword', checked)}
                        />
                        {
                            user.user.password  &&
                            <Alert target={"success"} className={"flex gap-2 items-center"}>
                                <FaTriangleExclamation /> Senha definida manualmente
                            </Alert>
                        }

                        {
                            !projectUtils.hasValue(user.user.password) &&
                            <Button onClick={definePassword} disabled={!user.user.status}>
                                Definir senha
                            </Button>
                        }

                        <div>
                            {
                                user.user.dateChangePassword &&
                                <Alert className={"!text-[13px]"} target={"info"}>
                                    <b>Última troca de senha:</b> {projectUtils.formatDate(user.user.dateChangePassword)}
                                </Alert>
                            }
                        </div>
                    </div>
                </Card.Body>
            </Card>

            <Card>
                <Card.Header>
                    <Card.Title>Efetivo</Card.Title>
                </Card.Header>
                <Card.Body>
                    <InputSwitch
                        disabled={!user.user.status}
                        labelStyle={{fontSize: "15px"}}
                        id="effectiveStatus"
                        label="O Agente faz parte da lista de efetivo?"
                        checked={user.user.effectiveStatus}
                        onChange={(checked) => onChange('effectiveStatus', checked)}
                    />
                </Card.Body>
            </Card>

            {
                id && <Vms user={user} setIsLoading={setIsLoading}/>
            }

            <Card>
                <Card.Header>
                    <Card.Title>Observações</Card.Title>
                </Card.Header>
                <Card.Body>
                    <InputTextarea textAreaClass={"h-[calc(100vh-772px)] min-h-30"} label="Observações" id={"observation"}
                           value={user.user.observation}
                           onChange={({target: {value, id}}) => onChange(id, value)}/>
                </Card.Body>
            </Card>

            <LoginBlock
                open={loginBlockModal}
                setOpen={setLoginBlockModal}
            />

            <ChangePassword
                open={changePasswordModal}
                setOpen={setChangePasswordModal}
            />
        </div>
    );
};

export default User;